import { AriaColorSliderOptions, useColorSlider } from "@react-aria/color";
import { useColorSliderState } from "@react-stately/color";
import * as React from "react";
import { useFocusRing, useLocale } from "react-aria";
import { Field } from "../form/field";

type ColorSliderProps = Omit<AriaColorSliderOptions, "trackRef" | "inputRef">;

export function ColorSlider({ label, ...props }: ColorSliderProps) {
  const { locale } = useLocale();
  const state = useColorSliderState({ ...props, locale });
  const trackRef = React.useRef(null);
  const inputRef = React.useRef(null);

  const { labelProps, trackProps, thumbProps, inputProps } = useColorSlider(
    {
      ...props,
      label,
      "aria-label": props["aria-label"] ?? "color-slider",
      inputRef,
      trackRef,
    },
    state
  );

  const { focusProps, isFocusVisible } = useFocusRing();

  return (
    <Field
      label={label}
      className="p-color-slider"
      replaceDefaultControlWrapper
      labelProps={labelProps}
    >
      <div
        {...trackProps}
        data-focus-visible={isFocusVisible}
        data-bg={trackProps.style?.background}
        className="p-color-slider-track"
        ref={trackRef}
        style={{
          ...trackProps.style,
          background: trackProps.style?.background,
        }}
      >
        <div className="p-color-slider-checkers"></div>
        <div
          className="p-color-slider-thumb"
          {...thumbProps}
          style={{
            ...thumbProps.style,
            background: state.getDisplayColor().toString("css"),
          }}
        >
          <input ref={inputRef} {...inputProps} {...focusProps} />
        </div>
      </div>
    </Field>
  );
}
